import ResourcesPage from './ResourcesPage';

export default ResourcesPage;
